import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';

import { FactoringExtension } from '../../../../../services/redux/documentProfileSlice.types';
import { formatDate } from '../../../../functions/utils';

interface ExtensionsTooltipProps {
  extensions: FactoringExtension[];
}

const ExtensionsTooltip: React.FC<ExtensionsTooltipProps> = ({
  extensions,
}) => {
  // Ordenar extensiones por dueDate descendente (más reciente primero)
  const sortedExtensions = [...extensions].sort((a, b) => {
    const dateA = new Date(a.dueDate).getTime();
    const dateB = new Date(b.dueDate).getTime();
    return dateB - dateA;
  });

  return (
    <Box sx={{ p: 1 }}>
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 600,
          mb: 2,
          fontSize: '0.875rem',
          textAlign: 'center',
        }}
      >
        Prórrogas
      </Typography>
      <Table size="small" sx={{ minWidth: 300 }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant="body2" fontWeight="bold">
                Fecha Inicio
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" fontWeight="bold">
                Fecha Vencimiento
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" fontWeight="bold">
                Tasa
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" fontWeight="bold">
                Estado
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedExtensions.map((extension) => (
            <TableRow key={extension.id}>
              <TableCell>
                <Typography variant="body2">
                  {formatDate(new Date(extension.startDate), 'dd-mm-yyyy')}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {formatDate(new Date(extension.dueDate), 'dd-mm-yyyy')}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{extension.rate}%</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{extension.statusEsp}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ExtensionsTooltip;
